import { useEffect, useState } from 'react'

import { Box, BoxProps } from '@mantine/core'
import { useInView } from 'react-intersection-observer'

import { RichTextFormat } from 'components/atoms/richTextFormat'

import useStyles from './index.styles'
type Props = {
  heading: string
  description: string
  image: string
  innerClass?: string
} & BoxProps

export const InfoGardientSection = ({
  heading,
  description,
  image,
  innerClass,
  className,
  classNames,
  styles,
}: Props) => {
  const { ref, inView } = useInView()

  const { classes, cx } = useStyles(undefined, {
    name: 'InfoGardientSection',
    styles,
    classNames,
  })

  const [fillBg, setFillBg] = useState(false)

  useEffect(() => {
    if (!fillBg && inView) {
      setFillBg(true)
    }
  }, [inView])

  return (
    <Box className={cx(className, classes.root)} ref={ref}>
      <div className={cx(innerClass, classes.inner)}>
        <div className={classes.header}>
          <img
            loading="lazy"
            src={image}
            className={classes.thumbnail}
            alt={'Hello Bacsi'}
          />
          <div className={classes.heading}>
            <div>Hello Bacsi</div>
            <div>{heading}</div>
          </div>
        </div>
        {description && (
          <div className={classes.descWrapper}>
            <RichTextFormat
              className={cx(classes.desc)}
              content={description}
            />
            <RichTextFormat
              className={cx(
                fillBg ? 'fill-bg' : '',
                classes.desc,
                classes.descOverlay,
              )}
              content={description}
            />
          </div>
        )}
      </div>
    </Box>
  )
}
